import React, { ReactElement } from "react";
import {
  Link as RouterLink,
  LinkProps as RouterLinkProps,
  useLocation,
} from "react-router-dom";
import { ListItem, ListItemIcon, ListItemText } from "@mui/material";
import clsx from "clsx";
import styles from "./list-item-link.module.scss";

export interface IListItemLink {
  icon?: React.FC;
  primary: any;
  to: string;
  classes?: {
    icon?: any;
  };
  onClick?: () => void;
  items?: IListItemLink[];
}

export const ListItemLink = (props: IListItemLink): ReactElement => {
  const { icon, primary, to, items } = props;
  const location = useLocation();

  const renderLink = React.useMemo(
    () =>
      React.forwardRef<any, Omit<RouterLinkProps, "to">>((itemProps, ref) => (
        <RouterLink to={to} ref={ref} {...itemProps} />
      )),
    [to]
  );

  const onClick = (): void => {
    if (props.onClick) {
      props.onClick();
    }
  };

  const renderChild = (item: IListItemLink, index: number) => {
    const renderChildLink = React.forwardRef<any, Omit<RouterLinkProps, "to">>(
      (itemProps, ref) => <RouterLink to={item.to} ref={ref} {...itemProps} />
    );

    return (
      <li className={styles.child} key={index + 1}>
        <ListItem
          button
          component={renderChildLink}
          classes={{ root: styles.root, selected: styles.selected }}
          selected={location.pathname === item.to}
          onClick={() => item.onClick && item.onClick()}
        >
          {item.icon ? (
            <ListItemIcon
              classes={{ root: clsx([styles.icon, item.classes?.icon]) }}
            >
              {React.createElement(item.icon)}
            </ListItemIcon>
          ) : null}
          <ListItemText
            classes={{ primary: styles.text }}
            primary={item.primary}
          />
        </ListItem>
      </li>
    );
  };

  return (
    <>
      <li key={0}>
        <ListItem
          button
          component={renderLink}
          classes={{ root: styles.root, selected: styles.selected }}
          selected={location.pathname === to}
          onClick={() => onClick()}
        >
          {icon ? (
            <ListItemIcon
              classes={{ root: clsx([styles.icon, props.classes?.icon]) }}
            >
              {React.createElement(icon)}
            </ListItemIcon>
          ) : null}
          <ListItemText classes={{ primary: styles.text }} primary={primary} />
        </ListItem>
      </li>
      {items && items.length > 0 && (
        <>{items.map((item, index) => renderChild(item, index))}</>
      )}
    </>
  );
};
